import React from "react";
import { useTranslation } from "react-i18next";

import {
    Card,
    CardHeader,
    CardHeaderTitle,
    SortRow,
    FilterLabel,
    SmallToggle,
    ResetIconButton,
} from "./styled";
import { ResetIcon } from "./ResetIcon";
import { SortKey } from "./types";

type SortCardProps = {
    sortOptions: Record<SortKey, boolean>;
    mainColor: string;
    onToggle: (key: SortKey) => void;
    onReset: () => void;
};

export function SortCard({
    sortOptions,
    mainColor,
    onToggle,
    onReset,
}: SortCardProps): JSX.Element {
    const { t } = useTranslation();

    const SORT_LABELS: Record<SortKey, string> = {
        pendingFirst: t("Pending first"),
        unpaidFirst: t("Unpaid first"),
        totalDesc: t("Total descending"),
        totalAsc: t("Total ascending"),
        byNumber: t("By number"),
    };

    return (
        <Card>
            <CardHeader>
                <CardHeaderTitle>{t("Sorting options")}</CardHeaderTitle>
                <ResetIconButton
                    data-testid="servio-home-reset-sort-btn"
                    mainColor={mainColor}
                    onClick={onReset}
                    title={t("Reset to default")}
                >
                    <ResetIcon />
                    {t("Reset")}
                </ResetIconButton>
            </CardHeader>
            {(Object.keys(SORT_LABELS) as SortKey[]).map((key) => (
                <SortRow key={key} data-testid={`servio-home-sort-${key}`}>
                    <SmallToggle
                        data-testid={`servio-home-sort-${key}-toggle`}
                        isActive={sortOptions[key]}
                        mainColor={mainColor}
                        onClick={() => onToggle(key)}
                    />
                    <FilterLabel>{SORT_LABELS[key]}</FilterLabel>
                </SortRow>
            ))}
        </Card>
    );
}
